import createHistory from 'history/createBrowserHistory'
import createMemoryHistory from 'history/createMemoryHistory'

import {IS_BROWSER} from '../constants/environment'

export const history = IS_BROWSER ? createHistory(): createMemoryHistory()

export const getLocation = () => history.location



// WEBPACK FOOTER //
// ./src/utils/history.js